// extracted by LIB_CSS_EXTRACT_LOADER
import "./button-group_module.css"
export default {"root":"root-Z5pCsu","horizontal":"horizontal-kveVYa","vertical":"vertical-L4G4Ah","text":"text-VDSn9t","separator":"separator-yqxF4d"};